/*@flow*/
import isType from './isType';

export default function isMaybe(x: any): %checks {
  return isType(x) && x.meta.kind === 'maybe';
}
